var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper "},[_c('div',{staticClass:" bg-white",attrs:{"id":"donate"}},[_c('div',[_c('fade-transition',{attrs:{"duration":200,"origin":"center top","mode":"out-in"}},[_c('router-view')],1)],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }